import { render, staticRenderFns } from "./ResIpsubnet.vue?vue&type=template&id=21393b85&scoped=true"
import script from "./ResIpsubnet.vue?vue&type=script&lang=js"
export * from "./ResIpsubnet.vue?vue&type=script&lang=js"
import style0 from "./ResIpsubnet.vue?vue&type=style&index=0&id=21393b85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21393b85",
  null
  
)

export default component.exports